module.exports = __webpack_public_path__ + "static/media/ni.b828dceb.svg";